import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--save-and-return-home"
export default class extends Controller {
  connect() {}

  saveAndReturn(e) {
    e.preventDefault();

    // 現在のフォームを取得
    const form =
      document.querySelector('form[method="put"]') ||
      document.querySelector("form");

    if (!form) {
      window.location.href = "/";
      return;
    }

    // フォームデータを収集
    const formData = new FormData(form);

    // next_view パラメータを追加してトップページに戻ることを指示
    formData.set("next_view", "return_home");

    // current_view も設定（既存の値があれば使用、なければ適当な値）
    if (!formData.has("current_view")) {
      formData.set("current_view", "profile"); // デフォルト値
    }

    // CSRFトークンを取得
    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");

    // HTTPメソッドを確認
    const method = form.method ? form.method.toUpperCase() : "PUT";

    // フォームを送信
    fetch(form.action, {
      method: method,
      body: formData,
      headers: {
        "X-CSRF-Token": csrfToken,
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => {
        // レスポンスの内容も確認
        return response.text().then((text) => {
          // 成功した場合（2xx系のステータス）はトップページにリダイレクト
          if (response.ok) {
            window.location.href = "/";
          } else {
            window.location.href = "/";
          }
        });
      })
      .catch((error) => {
        window.location.href = "/";
      });
  }
}
